/**
 * This reducer contains data related to routing, like redirect URL
 */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  redirectTo: null,
};

const routingSlice = createSlice({
  name: 'routing',
  initialState,
  reducers: {
    updateRedirectTo: (state, { payload }) => ({ ...state, redirectTo: payload }),
    reset: () => initialState,
  },
});

export const { updateRedirectTo, reset: resetRouting } = routingSlice.actions;

export default routingSlice.reducer;
